import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles } from 'lucide-react';
export function HeroImage() {
  return <section className="bg-white pb-10 px-6 md:px-12 lg:px-24" data-id="element-80">
      <div className="max-w-5xl mx-auto" data-id="element-81">
        <FadeIn delay={0.3} data-id="element-82">
          <div className="relative w-full rounded-2xl overflow-hidden shadow-xl" data-id="element-83">
            {/* Full hero image */}
            <div className="relative aspect-video" data-id="element-84">
              <img src="https://cdn.magicpatterns.com/uploads/dRR4RNUXjKFUyQgJNv4XXg/banner_Pagina_de_Venta_fuego_nadie_ve.png" alt="Ingredientes antiinflamatorios naturales sobre mesa de madera rústica: jengibre, ajo, cúrcuma, limones, canela, perejil, vinagre de manzana, cebolla morada y pimienta negra" className="w-full h-full object-cover" data-id="element-85" />

              {/* Warm overlay for text readability */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" data-id="element-86" />

              {/* Center label */}
              <div className="absolute inset-0 flex items-center justify-center z-10" data-id="element-87">
                <FadeIn delay={0.5} data-id="element-88">
                  <p className="text-center text-sm md:text-base uppercase tracking-[0.2em] text-white/80 font-bold drop-shadow-lg" data-id="element-89">
                    La botica de tu cocina
                  </p>
                </FadeIn>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}